import React from "react";
import { string } from "prop-types";

import "./sponsored.m.css";

const Sponsored = ({ fontColor = "#1A237E", bgColor = "#E3E6FF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    enableBackground="new 0 0 28 28"
    width="20"
    height="20"
    styleName="sponsored-icon"
    className="sponsored-icon"
  >
    <circle id="Ellipse_132" fill={bgColor} cx="14" cy="14" r="14" />
    <path
      id="Path_901"
      fill={fontColor}
      d="M8.099,12.981L5.537,14.46c-1.261,0.616-1.783,2.138-1.167,3.399
   c0.051,0.104,0.109,0.205,0.174,0.301l0.093,0.16c0.616,1.261,2.136,1.783,3.397,1.168c0.105-0.051,0.206-0.11,0.303-0.175
   l2.561-1.479L8.099,12.981z"
    />
    <path
      id="Path_902"
      fill={fontColor}
      d="M17.899,3.631c-0.168,0.104-0.289,0.269-0.337,0.46l-0.541,2.016
   c-0.126,0.4,0.096,0.828,0.496,0.954s0.828-0.096,0.954-0.496l0,0c0.007-0.02,0.013-0.041,0.017-0.062l0.541-2.016
   c0.116-0.403-0.116-0.825-0.52-0.941C18.303,3.487,18.082,3.517,17.899,3.631L17.899,3.631z"
    />
    <path
      id="Path_903"
      fill={fontColor}
      d="M20.343,8.013L20.343,8.013c-0.344,0.243-0.426,0.718-0.183,1.062
   c0.229,0.324,0.669,0.418,1.011,0.216l1.807-1.041c0.369-0.202,0.504-0.664,0.302-1.033c-0.202-0.369-0.664-0.504-1.033-0.302l0,0
   l-0.029,0.018l-1.809,1.048C20.386,7.99,20.364,8.001,20.343,8.013z"
    />
    <path
      id="Path_904"
      fill={fontColor}
      d="M20.9,11.76c-0.023,0.013-0.045,0.027-0.067,0.042c-0.34,0.247-0.415,0.723-0.167,1.063
   c0.105,0.144,0.256,0.246,0.428,0.29l2.016,0.54c0.396,0.14,0.83-0.068,0.97-0.464c0.14-0.396-0.068-0.83-0.464-0.97
   c-0.037-0.013-0.075-0.023-0.113-0.03l-2.02-0.538C21.287,11.637,21.078,11.661,20.9,11.76z"
    />
    <path
      id="Path_905"
      fill={fontColor}
      d="M20.931,16.352L14.399,5.04c-0.218-0.423-0.738-0.59-1.161-0.372s-0.59,0.738-0.372,1.161
   c0.013,0.025,0.027,0.05,0.043,0.074c-0.419,2.429-1.697,4.626-3.6,6.192l3.007,5.121c2.296-0.85,4.82-0.85,7.116,0
   c0.238,0.413,0.766,0.554,1.179,0.316s0.554-0.766,0.316-1.179L20.931,16.352z"
    />
    <path
      id="Path_906"
      fill={fontColor}
      d="M13.272,21.086l-1.951-2l-2.4,1.426l2.407,2.47c0.453,0.535,1.255,0.602,1.79,0.149
   c0.045-0.038,0.088-0.08,0.127-0.124c0.537-0.452,0.606-1.254,0.153-1.791C13.359,21.17,13.317,21.126,13.272,21.086z"
    />
  </svg>
);

Sponsored.propTypes = {
  fontColor: string,
  bgColor: string,
};

export default Sponsored;
